import { FC } from 'react';
import CodeArticle from './CodeArticle';
import PublicationSheet from './PublicationSheet';
import { useBookPageContext } from '@utils/context/book';

const Sheet: FC = () => {
    const { isLegitext } = useBookPageContext();

    return isLegitext ? <CodeArticle /> : <PublicationSheet />;
};

export default Sheet;
